import * as React from 'react';
import { FixMeLater } from '../../utils';
import { Stacker, StackerProps } from '../Stacker/Stacker';

export interface OptionListProps extends StackerProps {
    role?: string;
}

export const OptionList: React.ForwardRefExoticComponent<OptionListProps & React.RefAttributes<HTMLElement>> =
    React.forwardRef(function OptionList(
        props: OptionListProps,
        ref: React.ForwardedRef<FixMeLater>
    ): React.JSX.Element {
        const { role, ...other } = props;

        return <Stacker ref={ref} component="ul" role={role} spacing={0} {...other} />;
    });
